import React, { FC, ReactNode } from "react";
import { CustomCSSProperties } from "../../types";

export interface SlideProps extends React.HTMLAttributes<HTMLLIElement> {
    children?: ReactNode,
    className?: string,
    style?: CustomCSSProperties
}

export const Slide: FC<SlideProps> = ({children, className = '', style = {}, ...rest}) => {
    return (
        <li className={`slide w-100 h-100 p-a ${className}`} style={{...style}} {...rest}>
            {children}
        </li>
    )
}